/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Location
 */
export interface Location {
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    locationId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Location
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    locationCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    locationName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    countryCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    countryName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Location
     */
    countryEffective?: boolean | null;
    /**
     * 
     * @type {object}
     * @memberof Location
     */
    effectiveDateFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof Location
     */
    effectiveDateTo?: object | null;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    updatedBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Location
     */
    updatedDate?: Date;
}

export function LocationFromJSON(json: any): Location {
    return LocationFromJSONTyped(json, false);
}

export function LocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Location {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'locationId': !exists(json, 'locationId') ? undefined : json['locationId'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'locationCode': !exists(json, 'locationCode') ? undefined : json['locationCode'],
        'locationName': !exists(json, 'locationName') ? undefined : json['locationName'],
        'countryCode': !exists(json, 'countryCode') ? undefined : json['countryCode'],
        'countryName': !exists(json, 'countryName') ? undefined : json['countryName'],
        'countryEffective': !exists(json, 'countryEffective') ? undefined : json['countryEffective'],
        'effectiveDateFrom': !exists(json, 'effectiveDateFrom') ? undefined : json['effectiveDateFrom'],
        'effectiveDateTo': !exists(json, 'effectiveDateTo') ? undefined : json['effectiveDateTo'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
        'updatedDate': !exists(json, 'updatedDate') ? undefined : (new Date(json['updatedDate'])),
    };
}

export function LocationToJSON(value?: Location | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'locationId': value.locationId,
        'allowEdit': value.allowEdit,
        'locationCode': value.locationCode,
        'locationName': value.locationName,
        'countryCode': value.countryCode,
        'countryName': value.countryName,
        'countryEffective': value.countryEffective,
        'effectiveDateFrom': value.effectiveDateFrom,
        'effectiveDateTo': value.effectiveDateTo,
        'updatedBy': value.updatedBy,
        'updatedDate': value.updatedDate === undefined ? undefined : (value.updatedDate.toISOString()),
    };
}


